import { render, staticRenderFns } from "./Lembrete-Medicacao-Listagem.vue?vue&type=template&id=1be18ae4&"
import script from "./Lembrete-Medicacao-Listagem.vue?vue&type=script&lang=js&"
export * from "./Lembrete-Medicacao-Listagem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Lembrete-Medicacao-Listagem.vue"
export default component.exports